import { render, staticRenderFns } from "./ProductAdditionalFields.vue?vue&type=template&id=7ec79746&scoped=true&"
import script from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ProductAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAdditionalFields.vue?vue&type=style&index=0&id=7ec79746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec79746",
  null
  
)

export default component.exports